/** @jsx isolateComponent */
import { Fragment } from 'react';
import { GridLayout } from '@zapier/common-components';
import { isolateComponent, labelStyles } from '@zapier/common-utils';
import { Icon, IconName } from '@zapier/design-system';

import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';
import {
  CollapsedBlock,
  GlobalIncidents,
  RadioBlock,
  Separator,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';

import { ContactUs } from './ContactUs';
import { PartnerAdditionalHelp } from './AdditionalHelp/PartnerAdditionalHelp';
import { SolutionPartnerInfo } from './SolutionPartnerInfo';

type Item = {
  icon: IconName;
  label: string;
  value: string;
};

type TopicProps = {
  actions: {
    answer: (any) => void;
    unanswer: () => void;
  };
  isCurrent: boolean;
  data: any;
  label: string;
  items: Item[];
  state: string;
};

const Styles = labelStyles(__filename, {
  collapsed: {
    display: 'grid',
    gridColumnGap: 13,
    gridTemplateColumns: 'min-content 1fr',
  },
});

const Topic = (props: TopicProps) => {
  const {
    actions: { answer, unanswer },
    isCurrent,
    label,
    items,
    data,
    state,
  } = props;

  const { size } = useFormContext();

  if (!isCurrent) {
    const selectedItem = items.find(item => item.value === data) as Item;

    return (
      <CollapsedBlock
        isDimmed={state !== 'confirm'}
        onClickEdit={unanswer}
        size={size}
        title={label}
      >
        <div css={Styles.collapsed}>
          <Fragment>
            <Icon name={selectedItem.icon} size={20} /> {selectedItem.label}
          </Fragment>
        </div>
      </CollapsedBlock>
    );
  }

  return (
    <GridLayout gap={24}>
      <GlobalIncidents />
      <RadioBlock
        items={items}
        onClick={({ value }) => answer(value)}
        size={size}
        title={label}
      />
      <SolutionPartnerInfo />
      <ContactUs />
      <Separator />
      <PartnerAdditionalHelp size={size} />
    </GridLayout>
  );
};

export default Topic;
